import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { Button } from '../ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-background font-sans text-foreground overflow-x-hidden" data-id="element-390">
      <Header data-id="element-391" />
      <main className="flex-grow pt-20" data-id="element-392">{children}</main>
      <Footer data-id="element-393" />

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-6 left-4 right-4 md:hidden z-40" data-id="element-394">
        <a href="https://me.flinglink.app" data-id="element-395">
          <Button className="w-full shadow-xl" size="lg" style={{
          backgroundColor: '#ff6b6b'
        }} data-id="element-396">
            Get Your FlingLink
          </Button>
        </a>
      </div>
    </div>;
}